module.exports = __webpack_public_path__ + "static/media/undraw_access_denied_6w73_low_opacity.ce34b808.svg";